import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { PopupMessage } from '../models/popupMessage';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationPopupMessageService {
  // title: string,
  // header: string = "",
  // message: string,
  // agreeText: string = "",
  // doNotAgreeText: string = "",
  // btnOkText: string = 'OK',
  // btnCancelText: string = 'Cancel',
  // titleHide: number = 0,
  // headerHide: number = 0,
  // messageHide: number = 0,
  // agreeHide: number = 0,
  // doNotAgreeHide: number = 0,
  // btnOkHide: number = 0,
  // btnCancelHide: number = 0,

  constructor(private modalService: NgbModal) { }

  public confirm(
    msg:PopupMessage,
    dialogSize: 'sm'|'lg'|'xl' = 'sm'): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationPopupComponent, { size: dialogSize, centered: true });
    modalRef.componentInstance.msg = msg;
    // modalRef.componentInstance.title = title;
    // modalRef.componentInstance.header = header;
    // modalRef.componentInstance.message = message;
    // modalRef.componentInstance.agreeText = agreeText;
    // modalRef.componentInstance.doNotAgreeText = doNotAgreeText;
    // modalRef.componentInstance.btnOkText = btnOkText;
    // modalRef.componentInstance.btnCancelText = btnCancelText;
    // modalRef.componentInstance.titleHide = titleHide == 1 ? true : false;
    // modalRef.componentInstance.headerHide = headerHide == 1 ? true : false;
    // modalRef.componentInstance.messageHide = messageHide == 1 ? true : false;
    // modalRef.componentInstance.agreeHide = agreeHide == 1 ? true : false;
    // modalRef.componentInstance.doNotAgreeHide = doNotAgreeHide == 1 ? true : false;
    // modalRef.componentInstance.btnOkHide = btnOkHide == 1 ? true : false;
    // modalRef.componentInstance.btnCancelHide = btnCancelHide == 1 ? true : false;

    return modalRef.result;
  }
}
